import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { IDENTITY_PROVIDER_TABS, type IdentityProviderTab } from '@/features/access/access-tabs';
import { IdentityProviderDetailPage } from '@/features/access/identity-providers/identity-provider-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

export const Route = createFileRoute('/$tenant/identity-providers/$identityProviderId')({
  validateSearch: (search: Record<string, unknown>): { tab: IdentityProviderTab } => ({
    tab: IDENTITY_PROVIDER_TABS.parse(search['tab']),
  }),
  component: IdentityProviderRoute,
});

function IdentityProviderRoute() {
  const { tenant, identityProviderId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="members"
      crumbs={[
        { label: t('access.identityProviders.title') },
        { label: <EntityName tenantId={tenant} kind="identityProvider" id={identityProviderId} /> },
      ]}
    >
      <IdentityProviderDetailPage
        tenantId={tenant}
        identityProviderId={identityProviderId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
